module.exports = __webpack_public_path__ + "static/media/savi2.a285d1a3.png";